<!-- eslint-disable @angular-eslint/template/alt-text -->
<div cdkDragHandle class="photo" [style.height.px]="proportionalHeight">
  <span class="span-loading">Loading...</span>

  <ng-container *ngIf="!previewItem.isDouble">
    <img class="full" [src]="previewItem.image" (error)="imgErrorHandler($event)" alt="" />
  </ng-container>

  <ng-container *ngIf="previewItem.isDouble">
    <img class="image-preview left" [src]="previewItem.firstImage" (error)="imgErrorHandler($event)" />
    <img class="image-preview right" [src]="previewItem.secondImage" (error)="imgErrorHandler($event)" />
  </ng-container>

  <div class="flex photo-content jcsb">
    <rx-row class="photo-content-actions flex-nosize" [ngClass]="showCheckbox ? 'jcsb' : 'jcfe'">
      <mat-checkbox *ngIf="showCheckbox" [checked]="checked" (click)="checkedChanged($event)"></mat-checkbox>

      <div [rxRoleGuard]="rejectedRoles" *ngIf="showMenuHandle" class="action-controls flex flex-row flex-nosize">
        <rx-icon
          *ngIf="showMenuHandle"
          name="icon-shadow-menu"
          class="rel z1 cp"
          [class.disabled]="disableMenu"
          (click)="onMenuClicked($event)"
          [matMenuTriggerFor]="actionMenu"
          [matMenuTriggerData]="actionMenuContext"
        ></rx-icon>

        <rx-icon name="bundle" class="bundle-icon" size="20"></rx-icon>
      </div>
    </rx-row>

    <div class="description">
      {{ description }}
    </div>
  </div>

  <ng-content></ng-content>
</div>
